module.exports = __webpack_public_path__ + "img/lost-teddy-full.891bcb03.jpg";